export enum LeaveCaseNoteVisibilityOption {
	CaseEmployee = -1,
	Supervisors = -2,
	TenantRepresentatives = -3,
	CompanyRepresentatives = -4
}